export const odooDiscrepancy = {
  "Odoo IN<>PO": `Odoo Invoice<>Purchase Order`,
  odoo_discrepancy_item_quantity_mismatch: `Quantity '{{2}}' in item '{{1}}' does not match with quantity '{{4}}' in PO '{{3}}'`,
  odoo_discrepancy_item_unitprice_mismatch: `Unit price '{{2}}' in item '{{1}}' does not match with unit price '{{4}}' in PO '{{3}}'`,
  odoo_inpo_discrepancy_item_poline_notattached: `Item '{{1}}' has no PO line attached`,
  Odoo_INPO_Quantity_NotMatch: `Match invoice line quantity with PO line quantity`,
  Odoo_INPO_UnitPrice_NotMatch: `Match invoice line unit price with PO line unit price`,
  Odoo_INPO_Line_NotAttached: `Check if the PO line is missing in the invoice line`,
  Odoo_INPO_Quantity_NotMatch_description:
    " The quantity invoiced on a line item does not match the quantity authorised on the corresponding Odoo PO line.",
  Odoo_INPO_UnitPrice_NotMatch_description:
    "The unit price on an invoice line differs from the unit price agreed on the matched Odoo purchase order line.",
  Odoo_INPO_Line_NotAttached_description:
    "An invoice line has no linked Odoo PO line reference, meaning it cannot be traced back to an authorised purchase order line.",
};
